import Photos from "./Photos";
import "./Photos.scss";

export default Photos;
